import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _setup.name ? _c('span', [_vm._v("\n  " + _vm._s(_setup.name) + "\n")]) : _c('span', [_vm._v("\n  " + _vm._s(_vm.empty) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };